<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<button #focusableEleTop class="focusable-element"></button>
<div class="row" *ngIf="hasError || showAdminError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul *ngIf="hasError">
                <li *ngFor="let error of ErrorMessages">
                    <button [innerHtml]="error"></button>
                </li>
            </ul>
            <p *ngIf="showAdminError">{{ ExtAgentID }} agent is of Admin or Above</p>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <p class="required">All fields are required, unless marked as optional.</p>
    </div>
</div>
<form (keydown)="onKeyDown($event)">
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup [label]="'Enrollment Method'"
                                           [options]="optionrbEnrollmentMethod"
                                           [selectedValue]="selEnrollmentMethod"
                                           (onValueChange)="selectedRbtn($event)"
                                           [radioGroupName]="'EnrollmentMethod'">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isSingle">
        <div class="col-16">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup [label]="'Scope of Appointment'"
                                           [options]="optionrbScope"
                                           [selectedValue]="selSOA"
                                           (onValueChange)="dataEntryStep1.SOA = $event"
                                           [radioGroupName]="'ScopeofAppointment'">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isVisibleAgentId">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Agent ID for this enrollment'"
                                    [text]="agentUserName"
                                    (onValueChange)="dataEntryStep1.AgentID = $event"
                                    [validators]="[notBlankValidator]"
                                    [disabled]="isValidAgent" (blur)="updateAgentGroup()">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!isSingle">
        <div class="col-16">
            <div class="bottom-20">
                <groupplan [enrollmentDrugViewModel]="enrollment"></groupplan>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Submit</button>
        </div>
    </div>
</form>

